import uuid from '../utils/uuid.utils';

export class UrlEvent {
  static open(url, extraData = '') {
    window.__CAAS__.triggerNative(window.__CAAS__.events.openUrl, uuid(), {
      ...extraData,
      url,
    });
  }

  static intercept(url, redirectUrls, injectCss = '', extraData = {}) {
    window.__CAAS__.triggerNative(window.__CAAS__.events.interceptUrl, uuid(), {
      ...extraData,
      url,
      redirect_urls: redirectUrls,
      inject_css: injectCss,
    });
  }
}
